import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { appLocale } from 'helpers/format';
import './DateTime.scss';
/**
 * @component DateTime
 * @since 1.0.0
 */
export function DateTime(props) {
    const { style, value, date, time, m, d, y, hh, mm } = Object.assign({ style: 'normal', date: true, time: false, m: 'long', d: 'numeric', y: 'numeric', hh: 'numeric', mm: 'numeric' }, props);
    const className = classNames('text', 'date', 'date--' + style, { 'date--has-date': date }, { 'date--has-time': time }, props.className);
    const formated = toFormattedDate(value, Object.assign(Object.assign({}, props), { timeZone: props.timeZone }));
    return React.createElement("span", { className: className }, formated);
}
/**
 * @function toDate
 * @since 1.0.0
 * @hidden
 */
export function toFormattedDate(value, options = {}) {
    const opts = Object.assign({ date: true, time: false, yearOnly: false, m: 'long', d: 'numeric', y: 'numeric', hh: 'numeric', mm: 'numeric' }, options);
    const { date, time, yearOnly, w, d, m, y, hh, mm, ss, timeZone } = opts;
    const tz = timeZone || 'America/Montreal';
    const parsed = toDate(value);
    if (!parsed) {
        return '';
    }
    const output = [];
    if (date) {
        const dateOptions = {
            timeZone: tz
        };
        if (w)
            dateOptions.weekday = w;
        if (d)
            dateOptions.day = d;
        if (m)
            dateOptions.month = m;
        if (y)
            dateOptions.year = y;
        output.push(parsed.toLocaleDateString(appLocale(), dateOptions));
    }
    if (time) {
        // h23: some engines render midnight as "24:00" with hour12: false
        const timeOptions = {
            timeZone: tz,
            hourCycle: 'h23',
            hour: '2-digit',
            minute: '2-digit'
        };
        if (hh)
            timeOptions.hour = hh;
        if (mm)
            timeOptions.minute = mm;
        if (ss)
            timeOptions.second = ss;
        const timeStr = parsed.toLocaleTimeString('en-US', timeOptions);
        output.push(timeStr);
    }
    if (yearOnly) {
        const yearOptions = {
            timeZone: tz,
            year: 'numeric'
        };
        output.push(parsed.toLocaleDateString(appLocale(), yearOptions));
    }
    return output.join(' ');
}
/**
 * @function toDate
 * @since 1.0.0
 * @hidden
 */
function toDate(input) {
    var _a;
    if (typeof input === 'string') {
        // TIME-ONLY values stored as "HH:mm" or "HH:mm:ss"
        const timeOnly = input.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
        if (timeOnly) {
            const d = new Date();
            d.setHours(Number(timeOnly[1]), Number(timeOnly[2]), Number((_a = timeOnly[3]) !== null && _a !== void 0 ? _a : 0), 0);
            return d;
        }
        // DATE columns (no time) come back as "YYYY-MM-DDT00:00:00.000Z".
        // Parsing those as UTC then displaying in local TZ shifts the date back one day.
        // Detect plain dates or UTC-midnight timestamps and parse as local calendar date.
        const dateOnly = input.match(/^(\d{4})-(\d{2})-(\d{2})(T00:00:00(\.000)?Z)?$/);
        if (dateOnly) {
            return new Date(parseInt(dateOnly[1], 10), parseInt(dateOnly[2], 10) - 1, parseInt(dateOnly[3], 10));
        }
        return new Date(input);
    }
    return input;
}
